//sends a message to parent window or iframe
export const sendMessageToParent = (window, { type, payload }) => {
  const data = {
    type,
    payload,
  };
  window.parent.postMessage(data, "*");
};

// waits for messages from parent window or iframe
export const registerMessagesListener = (window, eventHandler) => {
  window.onmessage = eventHandler;
};

// stops listening for messages from parent window or iframe
export const deregisterMessagesListener = (window) => () => {
  window.onmessage = null;
};

export const sendMessageToIframe = (iframeElementId, { type, payload }) => {
  const iframe = document.getElementById(iframeElementId);
  if (iframe) {
    iframe.contentWindow.postMessage(
      {
        type,
        payload,
      },
      "*"
    );
  }
};
